import * as Sentry from '@sentry/react';


export const createChangeDeleteEventsAPI = async (shipment) => {

    // Returns { result: 'success' | 'failed', message }.  message is the back end's explanation when it rejects a change (for example a wrong dock location) so it can be shown to the user.
    // A timeout returns failed with the abort error message ("The user aborted a request").

    if (shipment.requestType !== "eventCreate" && shipment.requestType !== "eventChange" && shipment.requestType !== "eventRemove") {
        console.warn('createChangeDeleteEventsAPI saw a requestType it did not recongize!')
        return { result: 'failed', message: 'Unrecognized request type.' }
    }

    return await sendUpdate(shipment, 10000)

    async function sendUpdate(shipment, timeOutValue) {
        // console.log('createChangeDeleteEventsAPI sendUpdate', shipment, timeOutValue)
        return new Promise(function (resolve, reject) {
            let controller = new AbortController();
            var signal = controller.signal;
            let url =
                "https://api.shippersedge.com/schedule/shipment/"

            let myHeaders = new Headers();
            myHeaders.append("x-api-key", "vdhy8wwjUJrwhxFpfuECTiAW");
            myHeaders.append("Content-Type", "application/json;charset=UTF-8");
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                signal: signal,
                body: JSON.stringify(shipment)
            };

            let request = new Request(url, requestOptions);

            if (timeOutValue) {
                setTimeout(() => controller.abort(), timeOutValue);
            }
            fetch(request)
                .then(async (response) => {
                    let body = await response.json().catch(() => ({}))
                    if (!response.ok) {
                        console.error(
                            "createChangeDeleteEventsAPI.js error",
                            response.status,
                            body
                        );
                        resolve({ result: 'failed', message: body?.message || response.statusText })
                        return
                    }
                    resolve({ result: 'success', message: body?.message })
                })
                .catch((err) => {
                    console.error("createChangeDeleteEventsAPI API Request failed", err);
                    Sentry.captureException(err)
                    resolve({ result: 'failed', message: err?.message });
                });
        })
    }
};

export default createChangeDeleteEventsAPI
